
// import { color } from 'html2canvas/dist/types/css/types/color';
import html2canvas from 'html2canvas';

import React, { useState, useEffect } from 'react';
import { use } from 'react';
import Select, { components } from 'react-select';


const SingleSelectDropdown = ({ options, onChange, valueSet, tskCtg, placeHolder, addCandInfo, isEdit, relevantId, isSendMailPage }) => {
  //console.log("see option",valueSet);
  //const [selectedOptions, setSelectedOptions] = useState(addCandInfo ? valueSet :valueSet[0]);
  const [selectedOptions, setSelectedOptions] = useState({});
  useEffect(() => {
    //console.log("selected options on dropdown change in common component", selectedOptions, valueSet,relevantId);
    setSelectedOptions(valueSet); // Update state when valueSet changes
  }, [valueSet]);

  useEffect(() => {
    //console.log("selected options after set in dropdown : ",selectedOptions);
  }, [selectedOptions])

  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '35px',
      height: '35px',
      width: '265px',
      minWidth: isSendMailPage ? '25.8vw' : '250px',
      display: 'flex',
      position: 'relative',
      overflow: 'hidden',
      border: '1px solid #757EA5',
      padding: '5px',
      borderColor: state.isFocused ? '#02acf6' : '#cfd4e9',
    }),
    valueContainer: (base) => ({
      ...base,
      height: '25px',
      padding: '0 6px',
      position: 'static',
      overflow: 'hidden',
      flex: '1 1 auto',
      display: 'flex',
      flexWrap: 'nowrap',
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      whiteSpace: 'nowrap',
      alignItems: 'center',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      position: 'absolute',
      right: 0,
      top: 0,
      height: '100%',
      background: 'white',
      display: 'flex',
      alignItems: 'center',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '4px',
    }),
    container: (base) => ({
      ...base,
      width: isSendMailPage ? '25.8vw' : '250px',
    }),
    input: (base) => ({
      ...base,
      margin: '0',
      padding: '0',
    }),
    placeholder: (base) => ({
      ...base,
      margin: '0',
      color: '#757ea5'
    }),

  };
  var Spinner = require('react-spinkit');
  const spinner = [<Spinner name="three-bounce" color="#02acf6" />];

  const [loading, setLoading] = useState(false);

  const customMenuList = (props) => {
    //console.log("props.children : ", props.children.length,props,options,options.length,relevantId);
    //setLoading((options.length >= 1 || relevantId === "0" ) ? false : true);
    // let index = options.findIndex((option, i) => i > options.length > 1 ? 1 :0 && option.label === '--select--');
    // Filter out invalid options

    // const validOptions = options.filter(option => option.label !== undefined);
    // console.log('validOptions:', validOptions);

    // let index = validOptions.findIndex((option) => option.label === '--select--');
    // console.log('index:', index);
    let count = options.filter(option => option.label === '--select--').length;
    return (
      <components.MenuList {...props}>
        {loading ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span>All Levels completed</span>
        </div> : count === 2 ? <p style={{ color: "#757ea5", textAlign: 'center' }}>No departments available</p> :
          props.children}
      </components.MenuList>
    );
  };

  useEffect(() => {
    setLoading((options.length > 1 || relevantId === "0") ? false : true);
  }, [options.length, relevantId]);


  return (
    <div className="relative">

      <Select
        isMulti={false}
        value={selectedOptions}
        onChange={(selected) => {          
          onChange(selected, tskCtg);
        }}
        options={options.length > 1 ? options : spinner}
        placeholder={placeHolder ? placeHolder : 'Select...'}
        styles={customStyles}
        isDisabled={isEdit}
        components={{ MenuList: customMenuList }}
      />

    </div>
  )
}

export default SingleSelectDropdown